import React, { useEffect, useState } from "react";
import { Modal, Row, Col, notification, Button, Skeleton, Divider, Tag } from "antd";
import moment from "moment";
import axios from "axios";

const confirm = Modal.confirm;

const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message,
        description
    });
};

const labelSimNaoParcialmente = value => {
    if (value === "sim") return <Tag color="green">Sim</Tag>;
    if (value === "nao") return <Tag color="red">Não</Tag>;
    if (value === "parcialmente") return <Tag color="orange">Parcialmente</Tag>;
    return "-";
};

const labelSimNao = value => {
    if (value === "sim") return <Tag color="green">Sim</Tag>;
    if (value === "nao") return <Tag color="red">Não</Tag>;
    return "-";
};

const parseArray = value => {
    if (!value) return [];
    if (Array.isArray(value)) return value;

    try {
        const parsed = JSON.parse(value);
        return Array.isArray(parsed) ? parsed : [];
    } catch {
        return [];
    }
};

const parseObject = (value, fallback = {}) => {
    if (!value) return fallback;
    if (typeof value === "object" && !Array.isArray(value)) return value;

    try {
        const parsed = JSON.parse(value);
        return parsed && typeof parsed === "object" && !Array.isArray(parsed) ? parsed : fallback;
    } catch {
        return fallback;
    }
};

const ModalEstudoCasoFundamental = ({ id, visible, onCancel, onDelete }) => {
    const [estudo, setEstudo] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const carregarDetalhe = id => {
        setIsLoading(true);

        axios({
            method: "get",
            url: "/api/estudo-caso/carregar-estudo-infantil",
            params: { id }
        })
            .then(response => {
                const dados = response.data;

                const familiaTrajetoriaEscolar = parseObject(dados.familia_trajetoria_escolar, {
                    responsavel: "",
                    contato: "",
                    relacao_familia_escola: "",
                    marcacoes: [],
                    outro: "",
                    relato_familia_sobre_aluno: ""
                });

                const estudanteContextoEscolar = parseObject(dados.estudante_contexto_escolar, {
                    marcacoes: [],
                    comportamento_sala: "",
                    participacao_atividades: [],
                    participacao_outro: ""
                });

                const identificacaoDemandasBarreiras = parseObject(dados.identificacao_demandas_barreiras, {
                    marcacoes: [],
                    outro: ""
                });

                const potencialidadesAluno = parseObject(dados.potencialidades_aluno, {
                    o_que_faz_bem: "",
                    interesses_hiperfocos: "",
                    habilidades_talentos: "",
                    caracteristicas_positivas: ""
                });

                const necessidadesApoio = parseObject(dados.necessidades_apoio, {
                    marcacoes: [],
                    outro: "",
                    tipo_apoio_necessario: ""
                });

                const estrategiasPedagogicas = parseObject(dados.estrategias_pedagogicas, {
                    estrategias_utilizadas: "",
                    funcionaram: null,
                    novas_estrategias: ""
                });

                const observacoesFamilia = parseObject(dados.observacoes_familia, {
                    relato_desenvolvimento: "",
                    estrategias_funcionam_casa: ""
                });

                const alinhamentoEscolaFamilia = parseObject(dados.alinhamento_escola_familia, {
                    familia_ciente_intervencoes: null,
                    familia_disponibilidade_parceria: null,
                    familia_atividades_terapias_externas: null,
                    familia_atividades_terapias_dias: [],
                    familia_atividades_terapias_quais: "",
                    combinado_escola_familia: ""
                });

                setEstudo({
                    ...dados,
                    data_registro: dados.data_registro ? moment(dados.data_registro) : null,

                    familia_trajetoria_escolar: {
                        ...familiaTrajetoriaEscolar,
                        marcacoes: parseArray(familiaTrajetoriaEscolar.marcacoes)
                    },

                    estudante_contexto_escolar: {
                        ...estudanteContextoEscolar,
                        marcacoes: parseArray(estudanteContextoEscolar.marcacoes),
                        participacao_atividades: parseArray(estudanteContextoEscolar.participacao_atividades)
                    },

                    identificacao_demandas_barreiras: {
                        ...identificacaoDemandasBarreiras,
                        marcacoes: parseArray(identificacaoDemandasBarreiras.marcacoes)
                    },

                    potencialidades_aluno: potencialidadesAluno,

                    necessidades_apoio: {
                        ...necessidadesApoio,
                        marcacoes: parseArray(necessidadesApoio.marcacoes)
                    },

                    estrategias_pedagogicas: estrategiasPedagogicas,

                    observacoes_familia: observacoesFamilia,

                    alinhamento_escola_familia: {
                        ...alinhamentoEscolaFamilia,
                        familia_atividades_terapias_dias: parseArray(alinhamentoEscolaFamilia.familia_atividades_terapias_dias)
                    }
                });
            })
            .catch(error => {
                openNotificationWithIcon("error", "Erro", error.response?.data || "Ocorreu um erro ao carregar o estudo de caso.");
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const validarExcluir = () => {
        confirm({
            title: "Pretende remover este estudo de caso?",
            okText: "Confirmar",
            cancelText: "Cancelar",
            onOk: () => excluir()
        });
    };

    const excluir = () => {
        axios({
            method: "put",
            url: "/api/estudo-caso/excluir",
            params: { id }
        })
            .then(() => {
                openNotificationWithIcon("success", "Removido", "O estudo de caso foi removido com sucesso.");
                onDelete();
            })
            .catch(error => {
                openNotificationWithIcon("error", "Erro", error.response?.data || "Ocorreu um erro ao excluir o estudo de caso.");
            });
    };

    useEffect(() => {
        if (id && visible) {
            carregarDetalhe(id);
        }
    }, [id, visible]);

    const renderTags = arr =>
        arr && arr.length > 0
            ? arr.map(item => (
                  <Tag key={item} style={{ marginBottom: 4 }}>
                      {item}
                  </Tag>
              ))
            : "-";

    const renderField = (label, value, span = 12) => (
        <Col span={span}>
            <span className="field-label">{label}</span>
            <Skeleton loading={isLoading} paragraph={false} active width={30} className="field-skeleton">
                <p className="field-value">{value || "-"}</p>
            </Skeleton>
        </Col>
    );

    const renderFieldWide = (label, value) => (
        <Col span={24}>
            <span className="field-label">{label}</span>
            <Skeleton loading={isLoading} title={false} active width={30} className="field-skeleton">
                <p className="field-value">{value || "-"}</p>
            </Skeleton>
        </Col>
    );

    const renderTagField = (label, arr) => (
        <Col span={24}>
            <span className="field-label">{label}</span>
            <Skeleton loading={isLoading} title={false} active width={30} className="field-skeleton">
                <div style={{ marginTop: 4 }}>{renderTags(arr)}</div>
            </Skeleton>
        </Col>
    );

    return (
        <Modal
            title={
                <div>
                    <div style={{ fontWeight: "bold", fontSize: 16 }}>Estudo de caso</div>
                    <div style={{ fontSize: 12, color: "#888" }}>Visualização do estudo de caso</div>
                </div>
            }
            className="modal-detalhe-info"
            visible={visible}
            onCancel={onCancel}
            footer={[
                <Button key="cancelar" onClick={onCancel}>
                    Fechar
                </Button>,
                <Button key="eliminar" className="modal-detalhe-info-delete-btn" type="danger" onClick={validarExcluir}>
                    Excluir estudo
                </Button>
            ]}
            centered
            width={900}
            bodyStyle={{ maxHeight: "70vh", overflowY: "auto" }}
        >
            <div className="modal-detalhe-info__body">
                <div className="modal-detalhe-info__section">
                    <Divider orientation="left" style={{ fontWeight: "bold" }}>
                        1. Dados do aluno
                    </Divider>
                    <Row gutter={16} style={{ marginBottom: 12 }}>
                        {renderField("Nome do aluno", estudo?.nome_crianca, 24)}
                        {renderField("Turma/Ano", estudo?.turma_ano)}
                        {renderField("Idade", estudo?.idade)}
                        {renderField("Professor(a)", estudo?.professor)}
                        {renderField("Data", estudo?.data_registro ? estudo.data_registro.format("DD/MM/YYYY") : "-")}
                    </Row>

                    <Divider orientation="left" style={{ fontWeight: "bold" }}>
                        2. Conhecendo a família e a trajetória escolar
                    </Divider>
                    <Row gutter={16} style={{ marginBottom: 12 }}>
                        {renderField("Responsável", estudo?.familia_trajetoria_escolar?.responsavel)}
                        {renderField("Contato", estudo?.familia_trajetoria_escolar?.contato)}
                        {renderFieldWide(
                            "Como é a relação da família com a escola",
                            estudo?.familia_trajetoria_escolar?.relacao_familia_escola
                        )}
                        {/* {renderTagField("Trajetória escolar / histórico", estudo?.familia_trajetoria_escolar?.marcacoes)}
                        {estudo?.familia_trajetoria_escolar?.marcacoes?.includes("Outro") &&
                            renderFieldWide("Outro", estudo?.familia_trajetoria_escolar?.outro)}
                        {renderFieldWide("Relato da família sobre o aluno", estudo?.familia_trajetoria_escolar?.relato_familia_sobre_aluno)} */}
                    </Row>

                    <Divider orientation="left" style={{ fontWeight: "bold" }}>
                        3. Observação do estudante no contexto escolar
                    </Divider>
                    <Row gutter={16} style={{ marginBottom: 12 }}>
                        {renderTagField("Itens observados", estudo?.estudante_contexto_escolar?.marcacoes)}
                        {renderFieldWide(
                            "Como o aluno se comporta em sala de aula",
                            estudo?.estudante_contexto_escolar?.comportamento_sala
                        )}
                        {renderTagField("Participação nas atividades", estudo?.estudante_contexto_escolar?.participacao_atividades)}
                        {estudo?.estudante_contexto_escolar?.participacao_atividades?.includes("Outro") &&
                            renderFieldWide("Outro", estudo?.estudante_contexto_escolar?.participacao_outro)}
                    </Row>

                    <Divider orientation="left" style={{ fontWeight: "bold" }}>
                        4. Identificação de demandas e barreiras
                    </Divider>
                    <Row gutter={16} style={{ marginBottom: 12 }}>
                        {renderTagField("Quais dificuldades o aluno apresenta", estudo?.identificacao_demandas_barreiras?.marcacoes)}
                        {estudo?.identificacao_demandas_barreiras?.marcacoes?.includes("Outro") &&
                            renderFieldWide("Outro", estudo?.identificacao_demandas_barreiras?.outro)}
                    </Row>

                    <Divider orientation="left" style={{ fontWeight: "bold" }}>
                        5. Potencialidades do aluno
                    </Divider>
                    <Row gutter={16} style={{ marginBottom: 12 }}>
                        {renderFieldWide("O que o aluno faz bem", estudo?.potencialidades_aluno?.o_que_faz_bem)}
                        {renderFieldWide("Interesses / hiperfocos", estudo?.potencialidades_aluno?.interesses_hiperfocos)}
                        {renderFieldWide("Habilidades e talentos observados", estudo?.potencialidades_aluno?.habilidades_talentos)}
                        {renderFieldWide("Características positivas do aluno", estudo?.potencialidades_aluno?.caracteristicas_positivas)}
                    </Row>

                    <Divider orientation="left" style={{ fontWeight: "bold" }}>
                        6. Necessidades de apoio
                    </Divider>
                    <Row gutter={16} style={{ marginBottom: 12 }}>
                        {renderTagField("O aluno necessita de apoio para", estudo?.necessidades_apoio?.marcacoes)}
                        {estudo?.necessidades_apoio?.marcacoes?.includes("Outro") &&
                            renderFieldWide("Outro", estudo?.necessidades_apoio?.outro)}
                        {renderFieldWide("Tipo de apoio necessário", estudo?.necessidades_apoio?.tipo_apoio_necessario)}
                    </Row>

                    <Divider orientation="left" style={{ fontWeight: "bold" }}>
                        7. Estratégias pedagógicas
                    </Divider>
                    <Row gutter={16} style={{ marginBottom: 12 }}>
                        {renderFieldWide("Estratégias já utilizadas", estudo?.estrategias_pedagogicas?.estrategias_utilizadas)}
                        <Col span={24}>
                            <span className="field-label">Funcionaram?</span>
                            <Skeleton loading={isLoading} paragraph={false} active className="field-skeleton">
                                <div style={{ marginTop: 4 }}>{labelSimNaoParcialmente(estudo?.estrategias_pedagogicas?.funcionaram)}</div>
                            </Skeleton>
                        </Col>
                        {renderFieldWide("Novas estratégias a aplicar", estudo?.estrategias_pedagogicas?.novas_estrategias)}
                    </Row>

                    <Divider orientation="left" style={{ fontWeight: "bold" }}>
                        8. Observações da família
                    </Divider>
                    <Row gutter={16} style={{ marginBottom: 12 }}>
                        {renderFieldWide(
                            "Relato sobre o desenvolvimento do aluno e principais preocupações da família",
                            estudo?.observacoes_familia?.relato_desenvolvimento
                        )}
                        {renderFieldWide(
                            "O que a família considera que ajuda o aluno a aprender melhor, que estratégias funcionaram em casa",
                            estudo?.observacoes_familia?.estrategias_funcionam_casa
                        )}
                    </Row>

                    <Divider orientation="left" style={{ fontWeight: "bold" }}>
                        9. Alinhamento Escola e Família
                    </Divider>
                    <Row gutter={16} style={{ marginBottom: 12 }}>
                        <Col span={24} style={{ marginBottom: 8 }}>
                            <span className="field-label">A família está ciente das intervenções pedagógicas</span>
                            <Skeleton loading={isLoading} paragraph={false} active className="field-skeleton">
                                <div style={{ marginTop: 4 }}>
                                    {labelSimNaoParcialmente(estudo?.alinhamento_escola_familia?.familia_ciente_intervencoes)}
                                </div>
                            </Skeleton>
                        </Col>

                        <Col span={24} style={{ marginBottom: 8 }}>
                            <span className="field-label">A família demonstra disponibilidade para parceria com a escola</span>
                            <Skeleton loading={isLoading} paragraph={false} active className="field-skeleton">
                                <div style={{ marginTop: 4 }}>
                                    {labelSimNaoParcialmente(estudo?.alinhamento_escola_familia?.familia_disponibilidade_parceria)}
                                </div>
                            </Skeleton>
                        </Col>

                        <Col span={24} style={{ marginBottom: 8 }}>
                            <span className="field-label">A família leva o estudante para atividades ou terapias externas</span>
                            <Skeleton loading={isLoading} paragraph={false} active className="field-skeleton">
                                <div style={{ marginTop: 4 }}>
                                    {labelSimNao(estudo?.alinhamento_escola_familia?.familia_atividades_terapias_externas)}
                                </div>
                            </Skeleton>
                        </Col>

                        {estudo?.alinhamento_escola_familia?.familia_atividades_terapias_externas === "sim" && (
                            <>
                                {renderTagField("Dias da semana", estudo?.alinhamento_escola_familia?.familia_atividades_terapias_dias)}
                                {renderField("Quais", estudo?.alinhamento_escola_familia?.familia_atividades_terapias_quais, 24)}
                            </>
                        )}

                        {renderFieldWide(
                            "Combinado entre escola e família / orientações",
                            estudo?.alinhamento_escola_familia?.combinado_escola_familia
                        )}
                    </Row>

                    <Divider orientation="left" style={{ fontWeight: "bold" }}>
                        10. Recomendações finais
                    </Divider>
                    <Row gutter={16} style={{ marginBottom: 12 }}>
                        {renderFieldWide("Descrição", estudo?.recomendacoes_finais)}
                    </Row>
                </div>
            </div>
        </Modal>
    );
};

export default ModalEstudoCasoFundamental;
